<template>
  <div>
    <button
      style="display: none"
      type="button"
      class="btn-show-view-edit-item-applied-modal"
      data-bs-toggle="modal"
      data-bs-target="#modalViewEditItemApplied"
    ></button>
    <button
      style="display: none"
      type="button"
      class="btn-close-modal-view-edit-item-applied"
      data-bs-dismiss="modal"
      data-bs-target="#modalViewEditItemApplied"
    ></button>
    <div
      class="modal fade"
      id="modalViewEditItemApplied"
      tabindex="-1"
      aria-labelledby="modalViewEditItemAppliedLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalViewEditItemAppliedLabel">
              Select Item(s)
            </h5>
            <i
              style="cursor: pointer"
              class="material-icons justify-content-end"
              data-bs-dismiss="modal"
              aria-label="Close"
              >clear</i
            >
          </div>
          <div class="modal-body">
            <div class="d-flex align-items-center mt-3">
              <label class="fw-bold mb-0 me-3" for>Select All</label>
              <div class="d-flex">
                <div
                  :class="{ active: isActiveSelectAll }"
                  class="toggle_container pt-1"
                >
                  <MaterialToggleButton
                    labelEnableText
                    labelDisableText
                    id="event_handle"
                    v-on:change="triggerEvent"
                    class="mb-0"
                  />
                </div>
              </div>
            </div>
            <div
              class="input-group d-flex position-relative mt-5 row"
            >
              <div class="col-lg-3 col-12">
                <label for="search-input" class="text-bold"
                  >Items</label
                >
              </div>
              <div class="col-lg-9 col-12">
                <Multiselect
                  v-model="itemSelected"
                  mode="tags"
                  :searchable="true"
                  :options="items"
                  placeholder="Select items"
                  :canClear="false"
                  :disabled="selecteAll"
                  @search-change="searchItem"
                />
              </div>
            </div>
            <!-- <div
              class="input-group d-flex position-relative mt-5 row"
            >
              <div class="col-lg-3 col-12">
                <label for="search-input" class="text-bold">Report Type</label>
              </div>
              <div class="col-lg-9 col-12">
                <Multiselect
                  v-model="typeSelected"
                  mode="tags"
                  :close-on-select="true"
                  :searchable="true"
                  :options="types"
                  placeholder="Select types"
                  :canClear="false"
                  :disabled="selecteAll"
                />
                <div style="color: #007bff; margin-top: 5px">
                  (All items under the chosen Type(s) will be eligible)
                </div>
              </div>
            </div> -->
            <div
              class="input-group d-flex position-relative mt-4 row"
            >
              <div class="col-lg-3 col-12">
                <label for="search-input" class="text-bold">And Report Group</label>
              </div>
              <div class="col-lg-9 col-12">
                <Multiselect
                  v-model="groupSelected"
                  mode="tags"
                  :close-on-select="true"
                  :searchable="true"
                  :options="groups"
                  placeholder="Select groups"
                  :canClear="false"
                  :disabled="selecteAll"
                />
                <div style="color: #007bff; margin-top: 5px">
                  (All items under the chosen Group(s) will be eligible)
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-success btn-background btn-sm"
              @click="savePreferences"
            >
              Save Preferences
            </button>
          </div>
        </div>
        <material-loading :active="loaderActive" />
      </div>
    </div>
    <div class="position-fixed top-1 end-1 z-index-9999 message-success">
      <material-snackbar
        v-if="snackbar === 'danger' || snackbar === 'success'"
        title=""
        date=""
        :description="message"
        :icon="{ component: 'campaign', color: 'white' }"
        :color="snackbar"
        :close-handler="closeSnackbar"
      />
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import Multiselect from "@vueform/multiselect";
import SettingVoucherService from "../../../../services/settingVoucher.service";
import MaterialLoading from "@/components/MaterialLoading.vue";
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import MaterialToggleButton from "@/components/MaterialToggleButton.vue";

export default {
  name: "ModalViewEditItemApplied",
  components: {
    Multiselect,
    MaterialLoading,
    MaterialSnackbar,
    MaterialToggleButton,
  },
  props: {
    keyReload: {
      type: String,
      required: true,
    },
    rewardId: {
      type: Number,
      required: true,
    },
    typeIds: {
      type: Array,
      default: () => [],
    },
    groupIds: {
      type: Array,
      default: () => [],
    },
    itemIds: {
      type: Array,
      default: () => [],
    },
    checkAll: {
      type: Number,
      default: 1,
    },
    onChangeItemApplied: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      loaderActive: false,
      snackbar: null,
      message: "",
      items: [],
      itemsDefault: [],
      // types: [],
      groups: [],
      // typeSelected: [],
      groupSelected: [],
      itemSelected: [],
      selecteAll: 1,
      isActiveSelectAll: true,
    };
  },
  methods: {
    searchItem(keyword) {
      var dataSearch = this.itemsDefault;
      var dataResult = dataSearch.filter(
        (item) =>
          item.label.toLowerCase().indexOf(keyword.toLowerCase()) > -1 ||
          (item.item_no + "").indexOf(keyword) > -1
      );

      this.items = dataResult;
    },
    
    getFilterData() {
      this.showLoader();
      let dataForm = {
        reward_id: this.rewardId,
        get_group: 1,
        get_items: 1,
        get_items_apply_select: this.rewardId ? 1 : 0,
      };

      SettingVoucherService.getFilterData(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            const data = response.data.data;
            // this.types = data.dataTypeDropdown;
            this.groups = data.dataGroupDropdown;
            this.items = data.dataItemDropdown;
            this.itemsDefault = data.dataItemDropdown;

            if (this.rewardId) {
              // this.typeSelected = data.types_apply_select;
              this.groupSelected = data.groups_apply_select;
              this.itemSelected = data.items_apply_select;
              this.selecteAll = data.select_all ?? 1;
              this.isActiveSelectAll = this.selecteAll ? true : false;
            }
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    savePreferences() {
      if (this.rewardId) {
        let dataForm = {
          reward_id: this.rewardId,
          type: 2,
          item_ids: this.itemSelected,
          group_ids: this.groupSelected,
          // type_ids: this.typeSelected,
          select_all: this.selecteAll,
        };

        SettingVoucherService.applyForItems(dataForm).then(
          (response) => {
            if (response.data.result.isSuccess) {
              this.snackbar = "success";
              this.message = "Save success";
              this.setTimeOutNotification();
              $(".btn-close-modal-view-edit-item-applied").click();
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            this.hideLoader();
            this.setTimeOutNotification();
          }
        );
      } else {
        this.onChangeItemApplied(
          // this.typeSelected,
          this.groupSelected,
          this.itemSelected,
          this.selecteAll
        );
        $(".btn-close-modal-view-edit-item-applied").click();
      }
    },

    triggerEvent(value) {
      if (typeof value == "boolean") {
        this.isActiveSelectAll = !this.isActiveSelectAll;
        this.selecteAll = this.isActiveSelectAll ? 1 : 0;
      }
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },
  },
  watch: {
    keyReload: {
      handler() {
        this.types = [];
        this.groups = [];
        this.items = [];

        if (this.rewardId) {
          // this.typeSelected = [];
          this.groupSelected = [];
          this.itemSelected = [];
          this.selecteAll = 1;
          this.isActiveSelectAll = true;
        } else {
          // this.typeSelected = this.typeIds;
          this.groupSelected = this.groupIds;
          this.itemSelected = this.itemIds;
          this.selecteAll = this.checkAll;
          this.isActiveSelectAll = this.selecteAll ? true : false;
        }

        this.getFilterData();
      },
    },
  },
};
</script>

<style scoped>
.modal-dialog {
  max-width: 700px;
}
</style>
